import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Row } from "@faire/web--source/slate/Layout";
import React from "react";
import { SDUICarouselButton } from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarouselButton";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
export var SDUICarouselHeaderRow = function(param) {
    var title = param.title, cta_button = param.cta_button, sub_title = param.sub_title, tagline = param.tagline, loggingData = param.loggingData;
    if (!title && !sub_title && !tagline && !cta_button) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Row, {
        className: "justify-between items-center gap-2 pb-4 md:px-0 px-4",
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                className: "gap-1",
                children: [
                    tagline ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: tagline,
                        loggingData: loggingData
                    }) : null,
                    title ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: title,
                        loggingData: loggingData
                    }) : null,
                    sub_title ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: sub_title,
                        loggingData: loggingData
                    }) : null
                ]
            }),
            cta_button ? /*#__PURE__*/ _jsx(SDUICarouselButton, {
                button: cta_button,
                loggingData: loggingData
            }) : null
        ]
    });
};
